
<section class="content card">
    <div class="container-fluid card-body ">
        <div class="text-center" >
            <h4 class="font-weight-bold text-dark  text-center" >ENROLLED COURSE</h4>
      
        </div>
       
        <!-- <div class="row" >
            <div class="col-md-12" >

<div *ngIf="values.length>0">
    <h3>Availbale courses</h3>

             <div class="row">
                <div class="col-md-3" *ngFor="let item of values">
                    <div class="card"  >
                        <img class="card-img-top" style="height: 200px;" src="https://myroots.redmindtechnologies.com/api/{{item.image}}" alt="Card image">
                        <div class="card-body" style="height: 200px;">
                            <h4 class="card-title" style="font-weight:bold;font-size:16px;">{{item.course_name}}</h4>
                            <div class="card-text" style="font-size: 12px;">{{item.course_description}}</div> 
                            <span class="card-text" style="float:left">Start Date: {{item.start_date | date:'d-M-Y'}}</span>
                            <div class="card-text" style="font-size: 14px;">Duration: {{item.hours}} Hours</div>
                            <button class="btn btn-danger" style="float: right;" (click)="courseEnroll(item.course_id,item)">Enroll</button>
                            <button class="btn btn-primary" style="float: right;margin-right: 20px;" data-toggle="modal" data-target="#showCM"
                                (click)="buttonviewmeeting(item,'show')">Show</button>
                        </div>
                    </div>
                </div>
             </div></div>
             <div class=" col-md-12"  *ngIf="values.length<=0">
                <p style=" color: black;justify-content: center;
                display: flex;"> Course will be Appear soon..!</p>
              </div>
            </div>
       
             
             
        </div> -->
            <!-- <div class="row" *ngIf="enrolled_values.length > 0">
                <div class="col-md-12">
                    <h3>Enrolled courses</h3>
            
            
                    <div class="row">
                        <div class="col-md-3" *ngFor="let item of enrolled_values">
                            <div class="card">
                                <img class="card-img-top" style="height: 200px;" src="https://myroots.redmindtechnologies.com/api/{{item.image}}"
                                    alt="Card image">
                                <div class="card-body">
                                    <h4 class="card-title" style="font-weight:bold;font-size:16px;">{{item.course_name}}
                                    </h4>
                                    <div class="card-text" style="font-size: 12px;">{{item.course_description}}</div>
                                    <span class="card-text" style="float:left">Start Date: {{item.start_date | date:'d-M-Y'}}</span>
                                    <div class="card-text" style="font-size: 14px;">Duration: {{item.hours}} Hours</div>
                                    <div class="card-text" style="font-size: 14px;">Course Link: <a href={{item.session_link}}>{{item.session_link}}</a></div>
                                    <br/>
                                                                        <button class="btn btn-danger" style="float: right;"
                                                                            (click)="courseUnEnroll(item.course_id,item)">UnEnroll</button>
                                    <button class="btn btn-primary" style="float: right;" data-toggle="modal" data-target="#showCM"
                                         (click)="buttonviewmeeting(item,'show')"  style="float: right;margin-right: 20px;">Show</button>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
    </div>



    <!-- <div class="container-fluid">
        <h3>ENROLLED MENTOR COURSES</h3> 
        <div class="row">
          <div class="col-md-3" *ngFor="let course of enrolledCourses">
            <div class="card mb-4 shadow-sm" style="border:1px solid #a19e9e">
              <div class="card-header">
                <img class="card-img-top" style="height:150px;" src="../../../assets/dmk.png"
                alt="Card image">
              </div>
              <div class="card-body">
                <h3 style="font-weight:bold;font-size:20px;">{{ course.course_name }}</h3>
                <p class="card-text"><strong>Description:</strong> {{ course.course_des }}</p>
                <p class="card-text"><strong>Date:</strong> {{ course.course_date | date: 'dd-MM-yyyy' }}</p>
                <p class="card-text"><strong>Time:</strong> {{ course.course_time }}</p>
                <p class="card-text"><strong>Type of Course:</strong> {{ course.typeofcourse }}</p>
                <button class="btn btn-danger" style="float: right;"
                (click)="unenroll(course.id)">UnEnroll</button>
                <button class="btn btn-primary" style="float: right;margin-right: 10px;" data-toggle="modal" data-target="#enroll"
                (click)="showEnroll(course,'show')">show</button>
            </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="container-fluid">
        <div class="row">
            <div class="col-md-4 col-lg-3" *ngFor="let course of enrolledCourses">
                <div class="card mb-4" style="border: 1px solid #dee2e6; border-radius: 10px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);">
                    <div class="card-header p-0" style="border-bottom: none;">
                        <img class="card-img-top" style="height: 150px; border-radius: 10px 10px 0 0;" src="https://myroots.redmindtechnologies.com/api/{{course.images}}" alt="Card image">
                    </div>
                    <div class="card-body d-flex flex-column">
                        <h5 class="card-title font-weight-bold" style="font-size: 18px; color: #343a40;">{{ course.course_name }}</h5>
                        <p class="card-text text-muted" style="font-size: 14px;">
                            <strong>Description:</strong> {{ course.course_des }}
                        </p>
                        <p class="card-text text-muted" style="font-size: 14px;">
                            <strong>Date:</strong> {{ course.course_date | date: 'dd-MM-yyyy' }}
                        </p>
                        <p class="card-text text-muted" style="font-size: 14px;">
                            <strong>Time:</strong> {{ course.course_time }}
                        </p>
                        <p class="card-text text-muted" style="font-size: 14px;">
                            <strong>Type of Course:</strong> {{ course.typeofcourse }}
                        </p>
                        <div class="mt-auto d-flex justify-content-between">
                            <button class="btn btn-danger btn-sm" (click)="unenroll(course.id)">UnEnroll</button>
                            <button class="btn btn-primary btn-sm" data-toggle="modal" data-target="#enroll" (click)="showEnroll(course,'show')">Show</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class=" col-md-12"  *ngIf="enrolledCourses.length<=0">
                <p style=" color: black;justify-content: center;
                display: flex;"> Please Enroll in any Course of Choice...!</p>
              </div>
        </div>
    </div>
    
    

      <div class="modal fade" id="enroll" tabindex="-1" role="dialog" aria-labelledby="modalTitle" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header" style="background-color: #015792;color:white">
              <h5 class="modal-title" id="modalTitle">STUDENT ENROLL DETAILS</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div *ngIf="studentEnroll">
                <div class="container">
                    <div class="row">
                      <!-- Column 1 -->
                      <div class="col-md-6">
                            <p><strong>Course Name:</strong> {{ studentEnroll.course_name }}</p>
                            <p><strong>Course Date:</strong> {{ studentEnroll.course_date| date: 'dd-MM-yyyy' }}</p>
                            <p><strong>Course Time:</strong> {{ studentEnroll.course_time }}</p>
                          </div>
                          <div class="col-md-6">
                            <p><strong>Course Description:</strong> {{ studentEnroll.course_des }}</p>
                            <p><strong>Meeting Link:</strong> {{ studentEnroll.online_meet_link }}</p>
                            <p><strong>Type of course</strong> {{ studentEnroll.typeofcourse }}</p>
                      
                          </div>
                    </div>
                  </div>        
                 </div>
              <div *ngIf="!studentEnroll">
                <p>No details available.</p>
              </div>
            </div>
            <!-- <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div> -->
          </div>
        </div>
      </div>

    <div class="modal fade" id="showCM">
        <div class="modal-dialog modal-xl modal-dialog-centered">
            <div class="modal-content">
                <div class="card-success">
                    <div class="card-header">
                        <h3 class="card-title">COURSE DETAILS </h3>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="card-body">
                        <form class="register-form" [formGroup]='editmeetingform'
                            (ngSubmit)="updatedata(editmeetingform,CM_id)" autocomplete="off">
                            <div class= "row mb-2" *ngIf="!editfield" >
                                <div class="col-6 col-sm-12 col-md-6 row">
                                    <div class="col-sm-6 col-6" >
                                    <h6 class="f-w-500">Course Name<span class="pull-right"> :</span></h6>
                                </div>
                                <div class="col-sm-6 col-6"><h6>{{
                                 CM_course_name   }}</h6>
                            </div>
                        </div>
                        <div class="col-6 col-sm-12 col-md-6 row">
                            <div class="col-sm-6 col-6" >
                                <h6 class="f-w-500">District <span class="pull-right"> :</span></h6>
                               
                            </div>
                            <div class="col-sm-6 col-6"><h6>{{
                             CM_district  }}</h6>
                        </div>
                    </div>

                            </div>
                         
                            <div class= "row mb-2" *ngIf="!editfield" >
                                <div class="col-6 col-sm-12 col-md-6 row">
                                    <div class="col-sm-6 col-6" >
                                    <h6 class="f-w-500">Constituency<span class="pull-right"> :</span></h6>
                                </div>
                                <div class="col-sm-6 col-6"><h6>{{
                                 CM_constituency   }}</h6>
                            </div>
                        </div>
                        <div class="col-6 col-sm-12 col-md-6 row">
                            <div class="col-sm-6 col-6" >
                                <h6 class="f-w-500">Organizer <span class="pull-right"> :</span></h6>
                               
                            </div>
                            <div class="col-sm-6 col-6"><h6>{{
                             CM_organizer  }}</h6>
                        </div>
                    </div>

                            </div>
                            <div class= "row mb-2" *ngIf="!editfield" >
                                <div class="col-6 col-sm-12 col-md-6 row">
                                    <div class="col-sm-6 col-6" >
                                    <h6 class="f-w-500">Course Start Date<span class="pull-right"> :</span></h6>
                                </div>
                                <div class="col-sm-6 col-6"><h6>{{
                                 CM_startDate   }}</h6>
                            </div>
                        </div>
                        
                        <div class="col-6 col-sm-12 col-md-6 row">
                            <div class="col-sm-6 col-6" >
                                <h6 class="f-w-500">Course End Date <span class="pull-right"> :</span></h6>
                               
                            </div>
                            <div class="col-sm-6 col-6"><h6>{{
                             CM_endDate  }}</h6>
                        </div>
                    </div>
                            </div>

                            <div class= "row mb-2" *ngIf="!editfield" >
                                <div class="col-6 col-sm-12 col-md-6 row">
                                    <div class="col-sm-6 col-6" >
                                    <h6 class="f-w-500">Course Start Time<span class="pull-right"> :</span></h6>
                                </div>
                                <div class="col-sm-6 col-6"><h6>{{
                                 CM_startTime   }}</h6>
                            </div>
                        </div>
                        
                        <div class="col-6 col-sm-12 col-md-6 row">
                            <div class="col-sm-6 col-6" >
                                <h6 class="f-w-500">Course End Time <span class="pull-right"> :</span></h6>
                               
                            </div>
                            <div class="col-sm-6 col-6"><h6>{{
                             CM_endTime  }}</h6>
                        </div>
                    </div>
                            </div>
                            <div class= "row mb-2" *ngIf="!editfield" >
                                <div class="col-6 col-sm-12 col-md-6 row">
                                    <div class="col-sm-6 col-6" >
                                    <h6 class="f-w-500">Primary Volunteer<span class="pull-right"> :</span></h6>
                                </div>
                                <div class="col-sm-6 col-6"><h6>{{
                                 CM_volunteer1   }}</h6>
                            </div>
                        </div>
                        
                        <div class="col-6 col-sm-12 col-md-6 row">
                            <div class="col-sm-6 col-6" >
                                <h6 class="f-w-500">Secondary Volunteer <span class="pull-right"> :</span></h6>
                               
                            </div>
                            <div class="col-sm-6 col-6"><h6>{{
                             CM_volunteer2  }}</h6>
                        </div>
                    </div>
                            </div>

                            <div class= "row mb-2" *ngIf="!editfield" >
                                <div class="col-6 col-sm-12 col-md-6 row">
                                    <div class="col-sm-6 col-6" >
                                    <h6 class="f-w-500">Course Location<span class="pull-right"> :</span></h6>
                                </div>
                                <div class="col-sm-6 col-6"><h6>{{
                                 CM_location   }}</h6>
                            </div>
                        </div>
                        
                        <div class="col-6 col-sm-12 col-md-6 row">
                            <div class="col-sm-6 col-6" >
                                <h6 class="f-w-500">Course Link<span class="pull-right"> :</span></h6>
                               
                            </div>
                            <div class="col-sm-6 col-6"><h6>{{
                             CM_session_link  }}</h6>
                        </div>
                    </div>
                            </div>
                          

                            <div class= "row mb-2" *ngIf="!editfield" >
                                <div class="col-6 col-sm-12 col-md-6 row">
                                    <div class="col-sm-6 col-6" >
                                    <h6 class="f-w-500">Comments<span class="pull-right"> :</span></h6>
                                </div>
                                <div class="col-sm-6 col-6"><h6>
                                    {{CM_comments   }}</h6>
                            </div>
                        </div>
                        
                       
                            </div>
                            <div class="form-group row" *ngIf="editfield">
                                <div class="col-sm-6 mb-3 mb-sm-0">
                                    <label>Course Name </label><span class="required "> *</span>
                                    <select name="course_name" class="form-control" formControlName="course_name"
                                        [(ngModel)]="CM_course_name">
                                        <option value="">Select Course Name</option>
                                        <option *ngFor="let option of courses" [value]="option.id">
                                            {{option['course_name']}}</option>
    
                                    </select>
    
                                </div>
                                <div class="col-sm-6 mb-3 mb-sm-0">
                                    <label>District</label><span class="required "> *</span>
                                    <input pInputText type="text" class="form-control"
                                        placeholder="Enter District / மாவட்டம்" [value]="CM_district" readonly="readonly">
    
                                </div>
    
                            </div>
                            <div class="form-group row" *ngIf="editfield">
                                <div class="col-sm-6 mb-3 mb-sm-0">
                                    <label>Constituency</label><span class="required "> *</span>
                                    <input pInputText type="text" class="form-control"
                                        placeholder="Enter Constituency/ வாக்காளர் தொகுதி" [value]="CM_constituency"
                                        readonly="readonly">
    
                                </div>
                                <div class="col-sm-6 mb-3 mb-sm-0">
                                    <label>Organizer</label><span class="required "> *</span>
                                    <select name="organizer" class="form-control" formControlName="organizer"
                                        [(ngModel)]="CM_organizer">
                                        <option value="">Select Organizer</option>
                                        <option value="class">Class</option>
                                        <option *ngFor="let option of ob_data" (value)="option['firstname']">
                                            {{option['firstname']}}</option>
    
                                    </select>
    
                                </div>
                            </div>
                            <div class="form-group row" *ngIf="editfield">
                                <div class="col-sm-6 mb-3 mb-sm-0">
                                    <label class="form-label">Course Start Date</label><span class="required">*</span>
                                    <input pInputText type="date" class="form-control" placeholder="Enter Course Start Date"
                                        [value]="CM_startDate">
    
                                </div>
                                <div class="col-sm-6 mb-3 mb-sm-0">
                                    <label class="form-label">Course End Date</label><span class="required">*</span>
                                    <input pInputText type="date" class="form-control" placeholder="Enter Course End Date"
                                        [value]="CM_endDate">
    
                                </div>
                            </div>
                            <div class="form-group row" *ngIf="editfield">
                                <div class="col-sm-6 mb-3 mb-sm-0">
                                    <label class="form-label">Course Start Time</label><span class="required">*</span>
                                    <input pInputText type="time" class="form-control" placeholder="Enter Course Start Time"
                                        [value]="CM_startTime">
    
                                </div>
                                <div class="col-sm-6 mb-3 mb-sm-0">
                                    <label class="form-label">Course End Time</label><span class="required">*</span>
                                    <input pInputText type="time" class="form-control" placeholder="Enter Course End Time"
                                        [value]="CM_endTime">
    
                                </div>
                            </div>
                            <div class="form-group row" *ngIf="editfield">
                                <div class="col-sm-6 mb-3 mb-sm-0">
                                    <label class="form-label">Primary Volunteer</label><span class="required">*</span>
                                    <input pInputText type="text" class="form-control" placeholder="Enter Primary Volunteer"
                                        [value]="CM_volunteer1">
    
                                </div>
                                <div class="col-sm-6 mb-3 mb-sm-0">
                                    <label class="form-label">Secondary Volunteer</label><span class="required">*</span>
                                    <input pInputText type="text" class="form-control"
                                        placeholder="Enter Secondary Volunteer" [value]="CM_volunteer2">
    
                                </div>
                            </div>
                            <div class="form-group row" *ngIf="editfield">
                                <div class="col-sm-6 mb-3 mb-sm-0">
                                    <label class="form-label">Course Location</label><span class="required">*</span>
                                    <input pInputText type="text" class="form-control" placeholder="Enter Course Location"
                                        [value]="CM_location">
    
                                </div>
                                <div class="col-sm-6 mb-3 mb-sm-0">
                                    <label class="form-label">Status</label><span class="required">*</span>
                                    <select name="status" class="form-control" formControlName="status"
                                        [(ngModel)]="CM_status">
                                        <option value="">Select any status </option>
                                        <option>Open</option>
                                        <option>Session Start</option>
                                        <option>Session End</option>
                                        <option>Inprogress</option>
                                        <option>Cancelled</option>
                                        <option>Postponed</option>
                                    </select>
    
                                </div>
                            </div>
                            <div class="form-group row" *ngIf="editfield">
                                <div class="col-md-12">
                                    <label>Comments</label>
                                    <textarea class="form-control" formControlName="comments"
                                        [value]="CM_comments"></textarea>
                                </div>
                            </div>
    
                            <div *ngIf="editfield" class="d-flex justify-content-center">
                                <div style="width:200px">
                                    <button class="btn btn-success btn btn-block">Update District Occurance</button>
                                </div>
                            </div>
    
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

